import { inject } from '@angular/core';
import {
	CanActivateChildFn,
	CanActivateFn,
	Router,
	UrlTree,
} from '@angular/router';
import { UserService } from 'app/core/user/user.service';

export const TierGuard: CanActivateFn | CanActivateChildFn = (route, state) => {
	const userService: UserService = inject(UserService);
	const router: Router = inject(Router);

	const user = userService.userSig$();

	// If user info isn't ready yet, allow activation and let AuthGuard/resolvers
	// finish bootstrapping.
	if (!user) {
		return true;
	}

	const { accountTier } = user;

	if (
		accountTier === 'Simple' &&
		['document-templates', 'fields', 'roles'].some((segment) =>
			state.url.includes(segment)
		)
	) {
		return router.parseUrl('pages/error/401');
	}

	return true;
};
